import { Miniature } from '../../../models/miniature';

export const PreviousStepMiniature: Miniature = {
    group: '',
    highlights: ['Tag with value of previous step'],
    icon: 'fa-step-backward',
    sortingOrder: 20,
    title: 'Previous step',
    type: 'PreviousStep',
};